import { GetAssociatedDevicesInOrganisationQueryArg } from '../types/query-arg';
import { GetAssociatedDevicesInOrganisationQueryParams } from '../types/query-params';

export const getAssociatedDevicesInOrganisationQueryParams = (
  queryArg: GetAssociatedDevicesInOrganisationQueryArg,
): GetAssociatedDevicesInOrganisationQueryParams => ({
  organisationId: queryArg.organisation.id,
  unitId: 'ASSOCIATED',
});
